import { useQuery } from '@tanstack/react-query';
import { QUERIES_KEYS } from 'constant';
import { getFieldAttributes } from 'services/ticketService';
import { STATUS_FIELD_ID } from '../../../../constants';

const convertToSingleArray = (obj) => Object.values(obj).flat();

const useStatusList = () => {
  const { data, isFetched } = useQuery({
    queryKey: [QUERIES_KEYS.STATUS_LIST],
    queryFn: () => getFieldAttributes(STATUS_FIELD_ID),
    select: (result) => convertToSingleArray(result.values),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return { statusList: data, isFetched };
};

export default useStatusList;
